module.exports = __webpack_public_path__ + "img/title04_solgan_m.a6e5d0a4.png";